






































import NotificationUtils, { Notification } from '@/utils/NotificationUtils';
import mixins from 'vue-typed-mixins';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => Partial<Notification>,
    },
  },
});
